import axios from "axios";

/**
 * The Customer Liability signing flow is public: it must never carry a member
 * JWT and must never trigger the shared client's 401 interceptor (which pops
 * the login modal). It therefore uses its own bare axios instance.
 */
const BASE_URL = (
  process.env.REACT_APP_HOST_URL ||
  "https://bookingapidev.satyamholidays.net/api/"
).replace(/\/?$/, "/");

const client = axios.create({
  baseURL: `${BASE_URL}public/payment-agreements/`,
  timeout: 60000,
});

/** Surface the API's message so the payer sees why an upload was rejected. */
const toError = (error) => {
  const data = error?.response?.data;
  const wrapped = new Error(
    data?.message || error?.message || "Something went wrong. Please try again."
  );
  wrapped.code = data?.code;
  wrapped.status = error?.response?.status;
  wrapped.attemptsRemaining = data?.attemptsRemaining;
  wrapped.lockedUntil = data?.lockedUntil;
  return wrapped;
};

export const getAgreementState = async (token) => {
  try {
    const response = await client.get(encodeURIComponent(token));
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

export const unlockAgreement = async (token, file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("passport", file);

  try {
    const response = await client.post(
      `${encodeURIComponent(token)}/unlock`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
      }
    );
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

export const uploadSelfie = async (token, blob, accessToken, onUploadProgress) => {
  const formData = new FormData();
  // Text fields first: multer streams the parts in order, so the token is
  // parsed before the file rather than after it.
  formData.append("accessToken", accessToken);
  formData.append("selfie", blob, "selfie.jpg");

  try {
    const response = await client.post(
      `${encodeURIComponent(token)}/selfie`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
      }
    );
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

export const signAgreement = async (token, payload) => {
  try {
    const response = await client.post(
      `${encodeURIComponent(token)}/sign`,
      payload
    );
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};
